import React, {useCallback} from 'react';
import {
    Checkbox as MuiCheckbox,
    CheckboxProps,
    FormControl,
    FormControlLabel,
    FormControlLabelProps,
    FormControlProps,
    FormHelperText,
} from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import {useEditPanelContext} from '../../components/AdminDataGrid/EditPanelContext';
import {TEntity} from '../../../../models/entity';
import clsx from 'clsx';
import {makeStyles} from '@mui/styles';

export type CustomCheckboxProps = Omit<CheckboxProps,
    'name' | 'error' | 'onChange' | 'checked'> & {
    name?: string;
    error?: string;
    label?: string;
    marginTop?: boolean | number;
    marginBottom?: boolean | number;
    value: boolean | any;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
    onChange(evt: { target: { name: string; value: boolean } }): void;
    showFormHelperText?: boolean;
    formControlProps?: FormControlProps;
    formControlLabelProps?: Partial<FormControlLabelProps>;
};
export const redRequiredLabel = makeStyles((theme) =>({
  requiredLabelStyle: {
    '& .Mui-error': {
      color: 'red !important'
    }
  }
}));

export default function Checkbox(props: CustomCheckboxProps) {
    const {
        hidden,
        error,
        name,
        label,
        showFormHelperText,
        labelPlacement,
        value,
        marginBottom = 0.1,
        marginTop = 0.1,
        onChange,
        formControlLabelProps,
        formControlProps,
        ...other
    } = props;

    const convertToDefEventPara = (name: string, value: boolean) => ({
        target: {name, value},
    });

    const {validateField} = useEditPanelContext<TEntity>();
    const handleLoseFocus = useCallback((e: React.FocusEvent<HTMLButtonElement, Element>) => {
        if (!validateField || !props.required)
            return;
        validateField(e.target.value, e.target.name);
    }, [validateField, props.required]);

  const {requiredLabelStyle} = redRequiredLabel();
    return (
        <FormControl {...formControlProps} hidden={hidden} error={!!error}
                     className={clsx(other.className, formControlProps?.className, error ? requiredLabelStyle : '')}
                     sx={{
                         mt: typeof marginTop === 'number' ? marginTop : 1,
                         mb: typeof marginBottom === 'number' ? marginBottom : 1,
                     }}>
            <FormControlLabel
                style={{pointerEvents: 'none', ...formControlLabelProps?.style}}
                control={
                    <MuiCheckbox
                        style={{
                            ...props.style,
                            pointerEvents: 'auto',
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 5,
                            padding: 4,
                        }}
                        onBlur={(e) => handleLoseFocus(e)}
                        checkedIcon={<CheckBoxOutlinedIcon color={error ?'error' : undefined}/>}
                        {...other}
                        name={name}
                        checked={value}
                        onChange={(e) =>
                            onChange(convertToDefEventPara(name ?? '', e.target.checked))
                        }

                    />
                }
                label={label ?? ''}
                labelPlacement={props?.labelPlacement ?? 'end'}
            />

            {showFormHelperText && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
}
